import ContactInfoPage from "./ContactInfoPage";
import registrationStep from "../../registrationStep";

// export default connect(
//   (state) => ({
//     currentRegistrationId: state.registration.currentRegistrationId,
//     currentRegistration: getCurrentRegistration(state)
//   }),
//   (dispatch) => ({
//     onSubmit: (registrationId, contactInfo) => dispatch(Creators.saveContactInfo(registrationId, contactInfo))
//   })
// )(ContactInfoPage);

export default registrationStep(ContactInfoPage, "contact-info", "address");



// WEBPACK FOOTER //
// ./src/registration/components/ContactInfo/index.js